// Used for Global availabillity of some states
import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from "react";

import PeerConnectionManager
    from "../Services/PeerConnectionManager";

const PeerConnectionContext =
    createContext(null);

export function PeerConnectionProvider({
    children
}) {

    const [isConnected, setIsConnected] =
        useState(
            PeerConnectionManager.isConnected()
        );

    const [isHost, setIsHost] =
        useState(
            PeerConnectionManager.isHost
        );

    useEffect(() => {
        const unsubscribe =
            PeerConnectionManager.subscribe(
                (status) => {

                    setIsConnected(
                        status === "connected"
                    );

                    setIsHost(
                        PeerConnectionManager.isHost
                    );
                }
            );

        return () => {
            unsubscribe();
        };

    }, []);


    return (
        <PeerConnectionContext.Provider
            value={{
                isConnected,
                isHost
            }}
        >
            {children}
        </PeerConnectionContext.Provider>
    );
}

export function usePeerConnection() {

    const context =
        useContext(
            PeerConnectionContext
        );
    if (!context) {
        throw new Error(
            "usePeerConnection muss innerhalb von PeerConnectionProvider benutzt werden"
        );
    }
    return context;
}